import React from "react";
import Portfolio from "../components/Portfolio";
import { useTranslation } from "lib/i18n";
import Seo from "components/Seo";

const Works = () => {
  const { language } = useTranslation();
  const isFrench = language === "fr";
  const title = isFrench ? "Projets logiciels et études de cas" : "Software Projects and Case Studies";
  const description = isFrench
    ? "Découvrez des projets de développement logiciel, design produit et ingénierie livrés par Quivio."
    : "Explore selected custom software, product design, and engineering work delivered by Quivio.";

  return (
    <>
      <Seo title={title} description={description} path="/works" />
      <Portfolio />
    </>
  );
};

export default Works;
